import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function WriteOffIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.66699 8.6665V8.6725"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.333 7.32812V7.33412"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9997 12.3652C11.9997 12.3652 11.3822 12.3652 11.03 12.3652C9.79067 12.3652 8.65907 12.6109 7.79767 13.0158C6.93621 13.4208 5.80465 13.6665 4.56533 13.6665C3.87625 13.6665 3.22048 13.5906 2.62593 13.4535C2.24375 13.3654 2.05265 13.3213 1.82367 13.139C1.69307 13.035 1.53007 12.8291 1.45849 12.6777C1.33301 12.4124 1.33301 12.155 1.33301 11.6404V4.63142C1.33301 3.99063 2.00535 3.55052 2.62593 3.69358C2.91656 3.76058 3.27901 3.87046 3.59563 3.90653"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6663 11.6668V4.40948C14.6663 3.41374 14.3874 2.79328 13.3329 2.55176C12.7198 2.41133 12.0435 2.3335 11.3329 2.3335C10.0549 2.3335 8.88794 2.58526 7.99961 3.00016C7.51994 3.22418 6.94867 3.55188 6.33301 3.66683"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.17821 9.17884C8.87661 9.48044 8.45994 9.66698 7.99967 9.66698C7.07921 9.66698 6.33301 8.92078 6.33301 8.00031C6.33301 7.54004 6.51955 7.12338 6.82114 6.82178"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M1.33301 1.3335L14.6663 14.6668"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}
